import React from 'react'

export default function Partner() {
  return (
    <div>Partner</div>
  )
}

